import { queryClient } from 'App';

import { appointmentKeys } from 'lib/queries/appointmentKeys';

export default async (data) => {
  const { allergies = [], patientId } = data;
  // Coerce once so the compare and key match; a garbage id short-circuits.
  const pid = Number(patientId);
  if (!Number.isFinite(pid)) return;

  // Surgical patch on every cached `appointmentv2` detail for this patient.
  const allSingleAppointmentQueries = queryClient
    .getQueryCache()
    .findAll(appointmentKeys.detailsV2());
  for (const query of allSingleAppointmentQueries) {
    queryClient.setQueryData(query.queryKey, (oldData) => {
      if (Number(oldData?.appointment?.patient?.id) === pid) {
        return {
          ...oldData,
          appointment: {
            ...oldData?.appointment,
            allergies
          }
        };
      }
      return oldData;
    });
  }

  // Refresh the patient's list/overview rows (byPatient prefix; not the queue).
  queryClient.invalidateQueries({ queryKey: appointmentKeys.byPatient(pid) });
};
